let initialState = {
  scheduleObj: {
    IsScheduled: true,
    IsGenrate: 0,
    ScheduleType: "H",
    MailSentDate: "",
    startDate: null,
    endDate: null,
    selectedBrands: [],
    checkedAccounts: [],
    selectedBrandGroup: [],
    selectedFrequency: "Hourly",
    scheduleDay: null,
    scheduleTime: null,
    scheduleMonth: null,
    selectedLastXDays: null,
    selectedDataDuration: null,
    reportDeliveryTime: {
      startTime: "09:00 AM",
      endTime: "06:00 PM",
    },
    scheduleDate: "",
    type: "GenerateNow",
    selectedEmails: [],
    scheduleDays: [1, 2, 3, 4, 5, 6, 7],
    TimeOffsetText: "(GMT+05:30:00) Asia/Kolkata",
    timeOffset: 330,
    ScheduleDetails: JSON.stringify({
      timeOffsetText: "(GMT+05:30:00) Asia/Kolkata",
    }),
    hidden_filter: null,
    quick_filter: null,
  },
  templateObj: {
    brands: [],
    duration: null,
    filters: [],
    isPdfPreview: false,
    pdfEditorPanelSatus: false,
    pdfEditorPanelType: null,
    is_schedule_preview_list: false,
    is_schedule_preview_dashboard: false,
  },
  selectedBrands: [],
  checkedAccounts: [],
  selectedBrandGroup: [],
  selectedCompetitorBrands: [],
  searchResult: null,
  pdfEditorObj: {
    paneIndex: 0,
    panes: null,
    sectionIndex: null,
    widgetIndex: null,
    editorValue: null,
  },
  templateMetaDeta: null,
  widget_notes: null,
  brandsCategoryList: null,
  scheduleLoader: false,
  schedule_template_filters: {
    search_text: "",
    pill: "All Dashboards",
    offset: 0,
    no_of_rows: 12,
    sort_expression: "usage_count",
    sort_order: "desc",
    type: "dashboard",
  },
};
const scheduleReport = (state = initialState, action) => {
  switch (action.type) {
    case "SET_TEMPLATE_OBJECT":
      return {
        ...state,
        templateObj: action.templateObj,
      };
    case "SET_TEMPLATE_META_DATA":
      return {
        ...state,
        templateMetaDeta: action.templateMetaDeta,
      };
    case "SET_BRANDS_LIST":
      return {
        ...state,
        templateObj: action.templateObj,
      };
    case "SET_PDF_EDITOR_OBJECT":
      return {
        ...state,
        pdfEditorObj: action.pdfEditorObj,
      };
    case "SET_WIDGET_NOTE":
      return {
        ...state,
        widget_notes: action.widget_notes,
      };
    case "SET_WIDGET_NOTE_SECTION":
      let notes;
      if (action.widget_notes == null || action.widget_notes == undefined) {
        notes = null;
      } else {
        notes = [...(state.widget_notes || []), ...(action.widget_notes || [])];
      }

      return {
        ...state,
        widget_notes: notes,
      };
    case "SET_SCHEDULE_DURATION":
      return {
        ...state,

        scheduleObj: action.scheduleObj,
      };
    case "SET_SELECTED_BRANDS":
      return {
        ...state,
        selectedBrands: action.payload,
      };
    case "SET_CHECKED_ACCOUNTS":
      return {
        ...state,
        checkedAccounts: action.payload,
      };
    case "SET_SELECTED_BRANDS_GROUP":
      return {
        ...state,
        selectedBrandGroup: action.payload,
      };
    case "SET_SELECTED_COMETITOR_BRANDS":
      return {
        ...state,
        selectedCompetitorBrands: action.payload,
      };
    case "SET_REPORT_SEARCH_RESULT":
      return {
        ...state,
        searchResult: action.payload,
      };
    case "SET_BRANDS_CATEGORY_LIST":
      return {
        ...state,
        brandsCategoryList: action.payload,
      };
    case "SET_SCHEDULE_LOADER":
      return {
        ...state,
        scheduleLoader: action.payload,
      };
    case "SET_SCHEDULE_TEMPLATE_FILTERS":
      return {
        ...state,
        schedule_template_filters: action.payload,
      };
    case "SET_SCHEDULE_HIDDEN_FILTER":
      return {
        ...state,
        scheduleObj: action.scheduleObj,
      };
    case "SET_SCHEDULE_QUICK_FILTER":
      return {
        ...state,
        scheduleObj: action.scheduleObj,
      };
    default:
      return state;
  }
};

export default scheduleReport;
